import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

export function useDeleteFileMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutateAsync: deleteFileMutation, isLoading } = useMutation(
    ({ id, force }: { id: string; force?: boolean }) =>
      API_HANDLERS.FILES.DELETE(id, force ?? false),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['files']);
        alert.success(t('toasts.file.success.remove'));
      },
    },
  );

  return { deleteFileMutation, isLoading };
}
